// 参照组件类型(表参照/树参照/树表参照)
export const REFER_TYPE = {
    TABLE: 'Table',
    TREE_TABLE: 'TreeTable',
    TREE: 'Tree',
    TREE_LIST: 'TreeList',
    from: function(value) {
        switch(value) {
            case "TreeTable":
                return REFER_TYPE.TREE_TABLE;
            case "Tree":
                return REFER_TYPE.TREE;
            case "TreeList":
                return REFER_TYPE.TREE_LIST;
            default:
                return REFER_TYPE.TABLE; // Default
        }
    }
}

// 参照组件选择类型(单选/多选)
export const REFER_SELECT_TYPE = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    from: function(value) {
        switch(value) {
            case "multiple":
                return REFER_SELECT_TYPE.MULTIPLE;
            default:
                return REFER_SELECT_TYPE.SINGLE; //Default

        }
    }
}

// 参照组件渲染环境(pc端/移动端)
export const REFER_EQUIPMENT = {
    PC: 'pc',
    MOBILE: 'mobile',
    from: function(value) {
        switch(value) {
            case "pc":
                return REFER_EQUIPMENT.PC;
            default:
                return REFER_EQUIPMENT.MOBILE;
        }
    }
}